import { createSlice } from "@reduxjs/toolkit";

type InitGlobalState = {
  showMobileSideBar: boolean;
  userAvailableRevisions : number | null,
  hasUnsavedChanges: boolean,
  showAuthFormErrors: boolean,
};

const initialState: InitGlobalState = {
  showMobileSideBar: false,
  hasUnsavedChanges: false,
  showAuthFormErrors:false,
  userAvailableRevisions:null
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setShowMobileSideBar: (state, action) => {
        console.log(action);
      state.showMobileSideBar = action.payload;
    },
    setUserAvailableRevisions: (state, action) => {
      state.userAvailableRevisions = action.payload;
    },
    setShowAuthFormErrors: (state, action) => {
      state.showAuthFormErrors = action.payload;
    },

    setUnsavedChanges: (state, action) => {
      console.log('cicked');
      state.hasUnsavedChanges = action.payload;
    },
    resetUnsavedChanges: (state) => {
      state.hasUnsavedChanges = false;
    },
  },
});

export const { setShowMobileSideBar,setShowAuthFormErrors,setUserAvailableRevisions,setUnsavedChanges,resetUnsavedChanges } = globalSlice.actions;
export default globalSlice.reducer;
